import React, { useState, useEffect } from "react";
import { submitVote } from "../services/pollService";

const NewsPoll = ({ poll }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [hasVoted, setHasVoted] = useState(false);
  const [totalVotes, setTotalVotes] = useState(
    poll.options.reduce((sum, option) => sum + option.totalResponses, 0)
  );

  useEffect(() => {
    const votedPolls = JSON.parse(localStorage.getItem("votedPolls")) || [];
    setHasVoted(votedPolls.includes(poll.id));
  }, [poll.id]);

  const handleVote = async () => {
    if (!selectedOption) {
      alert("Please select an option before voting!");
      return;
    }

    try {
      const response = await submitVote(poll.id, selectedOption);

      if (response.success) {
        alert("Vote submitted successfully!");
        setHasVoted(true);
        
        // Store voted poll in local storage
        const votedPolls = JSON.parse(localStorage.getItem("votedPolls")) || [];
        votedPolls.push(poll.id);
        localStorage.setItem("votedPolls", JSON.stringify(votedPolls));

        // Update total votes (assuming backend updates poll data)
        setTotalVotes((prev) => prev + 1);
      } else {
        alert(response.message || "Failed to submit vote. Try again!");
      }
    } catch (error) {
      console.error("Error submitting vote:", error);
      alert("An error occurred while submitting your vote. Please try again.");
    }
  };

  return (
    <div className="news-poll">
      <h3 className="poll-question">{poll.question}</h3>
      <div className="poll-options">
        {poll.options.map((option) => {
          const percentage = totalVotes
            ? ((option.totalResponses / totalVotes) * 100).toFixed(1)
            : 0;
          return (
            <label key={option.optionId} className="poll-option">
              <input
                type="radio"
                name={`poll-${poll.id}`}
                value={option.optionId}
                checked={selectedOption === option.optionId}
                onChange={() => setSelectedOption(option.optionId)}
                disabled={hasVoted} // Disable selection if already voted
              />
              <span className="option-text">{option.optionText}</span>
              <span className="vote-percent">({percentage}%)</span>
            </label>
          );
        })}
      </div>
      <button className="vote-button" onClick={handleVote} disabled={hasVoted}>
        {hasVoted ? "Already Voted" : "Vote"}
      </button>
    </div>
  );
};

export default NewsPoll;